import { createFileRoute, redirect } from '@tanstack/react-router';
import { PurchaseOptions } from '../components/marketing/PurchaseOptions.tsx';
import { useSessionStore } from '../stores/session-store.ts';

export const Route = createFileRoute('/_funnel/start/paywall')({
  beforeLoad: () => {
    // Reachable both mid-funnel (face+voice captured) and from the in-app lock
    // CTAs (a completed scan in the store). Only a cold visitor with neither
    // gets sent back to start the scan.
    const { faceSummary, voiceSummary, lastScan } = useSessionStore.getState();
    if (!lastScan && (!faceSummary || !voiceSummary)) throw redirect({ to: '/start' });
  },
  component: FunnelPaywallPage,
});

function FunnelPaywallPage() {
  return (
    <div className="mx-auto max-w-md space-y-8 px-6 py-12">
      <header className="space-y-3 text-center">
        <p className="font-mono text-xs uppercase tracking-[0.32em] text-aurora">Unlock</p>
        <h1 className="font-display text-3xl text-ink-0">Unlock your full stability</h1>
        <p className="text-pretty text-ink-1">
          Keep your read, follow your protocol, and reach the energy range your system can maintain
          with consistent sessions.
        </p>
      </header>

      <PurchaseOptions />
    </div>
  );
}
